import React from 'react';

interface PsuLogoProps {
  className?: string;
}

export const PsuLogo: React.FC<PsuLogoProps> = ({ className = 'h-9 w-auto' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 93.52 50"
      className={`shrink-0 ${className}`}
      fill="none"
      aria-label="Prince of Songkla University Logo"
    >
      {/* Main PSU Typography */}
      <path
        className="fill-[#003C71] dark:fill-white"
        d="M15.41,22.61c-3.97,0-7.2-3.23-7.2-7.2s3.23-7.2,7.2-7.2,7.2,3.23,7.2,7.2-3.23,7.2-7.2,7.2M68.51.64v18.33c0,3.79-3.09,6.88-6.88,6.88s-6.88-3.09-6.88-6.88V.64h-8.21v13.83h-12.35c-1.18,0-2.3.19-3.37.54-.22-8.31-7.04-15.01-15.4-15.01S.07,6.85,0,15.3h0v23.78h8.21v-10.04c2.15,1.14,4.6,1.79,7.2,1.79,3.04,0,5.87-.89,8.26-2.41,1.31,4.57,5.52,7.93,10.51,7.93h5.83s1.13,0,1.13,0c1.5,0,2.72,1.22,2.72,2.72s-1.22,2.73-2.72,2.73h-16.48v8.21h16.48c6.03,0,10.93-4.91,10.93-10.94s-4.9-10.94-10.93-10.94h-5.84s-1.12,0-1.12,0c-1.5,0-2.72-1.22-2.72-2.72s1.22-2.73,2.72-2.73h12.82c1.66,6.53,7.59,11.38,14.63,11.38,8.32,0,15.09-6.77,15.09-15.09V.64h-8.21Z"
      />
      {/* Cyan Dot Accent */}
      <path
        className="fill-[#009CDE]"
        d="M93.52,5.96c0,3.18-2.58,5.76-5.76,5.76s-5.76-2.58-5.76-5.76S84.58.2,87.76.2s5.76,2.58,5.76,5.76"
      />
    </svg>
  );
};

export default PsuLogo;
